module.exports = __webpack_public_path__ + "img/headshot3.78f69f11.jpg";